import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useCheckPermission from '../../../../utils/checkPermission'
import {
  deleteEmailTemplateStart,
  getAllemailTemplatesStart,
  getImageGalleryStart,
  makePrimaryEmailTemplatesStart,
  resetEmailTemplate,
  updateEmailTemplateStatusStart
} from '../../../../store/redux-slices/emailTemplate'
import { getItem } from '../../../../utils/storageUtils'
import useLicenseList from '../../../../shared/hooks/useLicenseList'
import { checkIsTenant } from '../../../../utils/constants'

const useEmailTemplate = () => {
  const dispatch = useDispatch()
  const [show, setShow] = useState(false)
  const [type, setType] = useState(false)

  // Controls the visibility of the delete email template confirmation modal
  const [showDeleteEmailTemplateModal, setShowDeleteEmailTemplateModal] = useState(false)

  // Stores the details of the email template that is selected for deletion
  const [deleteEmailTemplateData, setDeleteEmailTemplateData] = useState(null)

  const [lang, setLang] = useState('EN')
  const tenantId = getItem('tenant-id')
  const [templateData, setTemplateData] = useState('')
  const { tenantDetails } = useSelector(state => state.login)
  const { isHidden } = useCheckPermission()
  const setModalData = (template, templateCode) => {
    setType(template)
    setTemplateData(templateCode)
    setShow(true)
  }

  const {
    emailTemplate,
    emailTemplates,
    templateCount,
    loading,
    emailTemplateOrder,
    emailTemplateDeleteLoader,
    emailTemplatesControlKeys,
    inactiveEmailTemplates
  } = useSelector((state) => state.emailTemplate)

  const selectedTenantId = getItem('tenant-id')
  const isTenant = checkIsTenant()
  const { licenseListOptions, selectedLicense, setSelectedLicense } = useLicenseList(isTenant ? selectedTenantId : '')

  useEffect(() => {
    dispatch(getAllemailTemplatesStart({ isTenant: true, licenseId: selectedLicense }))
    !isHidden({ module: { key: 'ImageGallery', value: 'R' } }) && dispatch(getImageGalleryStart({ isTenant: true, tenantId }))
  }, [selectedLicense])

  const resetEmail = () => dispatch(resetEmailTemplate())

  const onChangeEmailTemplateStatus = (emailTemplate, isActive) => {
    dispatch(updateEmailTemplateStatusStart({ emailTemplate, isActive, tenantId }))
  }

  /**
 * Handles the completion of the email template deletion process.
 * Closes the delete confirmation modal and resets the template data.
 */
  const handleDeleteComplete = () => {
    setShowDeleteEmailTemplateModal(false)
    setDeleteEmailTemplateData('')
    dispatch(getAllemailTemplatesStart({ isTenant: true, licenseId: selectedLicense }))
  }

  /**
 * Initiates the deletion of an email template.
 * Removes the label property before dispatching the delete action.
 */
  const handleDeleteEmailTemplate = () => {
    const dataWithoutLabel = { ...deleteEmailTemplateData }
    delete dataWithoutLabel.label
    dispatch(deleteEmailTemplateStart({
      emailtemplateDetail: dataWithoutLabel,
      handleDeleteComplete
    }))
  }

  return {
    emailTemplate,
    emailTemplates,
    loading,
    show,
    setShow,
    setModalData,
    templateData,
    templateCount,
    makePrimaryEmailTemplatesStart,
    dispatch,
    isHidden,
    emailTemplateOrder,
    languages: tenantDetails?.tenantConfig?.allowedLanguages,
    lang,
    setLang,
    resetEmail,
    type,
    emailTemplatesControlKeys,
    inactiveEmailTemplates,
    onChangeEmailTemplateStatus,
    isTenant,
    licenseListOptions,
    selectedLicense,
    setSelectedLicense,
    tenantId,
    showDeleteEmailTemplateModal,
    setShowDeleteEmailTemplateModal,
    emailTemplateDeleteLoader,
    deleteEmailTemplateData,
    setDeleteEmailTemplateData,
    handleDeleteEmailTemplate
  }
}

export default useEmailTemplate
